import styled from "styled-components";
// import { ShareBonusCollectModalIcon } from '@assets';
import { Modal as AntModal } from "antd";

export const Modal = styled(AntModal)`
  .ant-modal-footer {
    .ant-btn-primary {
      height: 30px !important;
    }
  }
`

export const CollectModalTitle = styled.div`
  margin-bottom: 10px;
  background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 145.455% */
`;

export const CollectModalQuestion = styled.div`
  display: block;

  color: #2A2A2A;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
`;